import { AppConstants } from 'src/app/shared/constants/constants';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class PageNotFoundComponent implements OnInit {
  message: string = AppConstants.COMMON_ERROR_MSGS.PAGE_NOT_FOUND_MSG;

  ngOnInit(): void {
    this.message = AppConstants.COMMON_ERROR_MSGS.PAGE_NOT_FOUND_MSG;
  }

}
